import React from 'react';
import { Resizable } from 'react-resizable';
import './index.scss';

const clearSelection = () => {
  if (window.getSelection) {
    const selection = window.getSelection();
    if (selection) {
      if (selection.empty) {
        // Chromeブラウザで誤選択されたテキストをクリアする
        selection.empty();
      } else if (selection.removeAllRanges) {
        // Firefoxブラウザで誤選択されたテキストをクリアする
        selection.removeAllRanges();
      }
    }
  } else if ((document as any).selection && (document as any).selection.empty) {
    // IEブラウザで誤選択されたテキストをクリアする
    (document as any).selection.empty();
  }
};

const ResizableTitle = (props) => {
  const { onResize, width, isResizable, ...restProps } = props;

  const handleResizeStart = () => {
    document.body.classList.add('resizing');
  };

  const handleResizeStop = (e, { size }) => {
    document.body.classList.remove('resizing');
    onResize(e, { size });
  };

  if (!width || !isResizable) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => e.stopPropagation()}
        />
      }
      onResize={onResize}
      onResizeStart={handleResizeStart}
      onResizeStop={handleResizeStop}
      draggableOpts={{
        enableUserSelectHack: false,
        onMouseDown: () => {
          // Windowsオペレーティングシステムで、EdgeブラウザとChromeブラウザで、マウスボタンを離しても依然としてドラッグできる問題を解決する
          clearSelection();
        },
      }}
      minConstraints={[50, 0]} // 最小幅を50ピクセルに設定する
      maxConstraints={[Infinity, 0]} // 最大幅を無限大に設定する
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTitle;